import { _ as __rest } from './_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { generateClasses } from '@ids/tools';
import { s as styleInject } from './style-inject.es.js';
import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import { I as IdsIcon } from './icon.js';
import { F as FormSelectionContext } from './form-selection.context.js';

var css_248z = "/*\n** Voxel Foundation Formats\n*/\n/*\n** Voxel Foundation Media Query Mixins\n*/\n/* stylelint-disable no-descending-specificity */\n/* stylelint-disable selector-pseudo-element-no-unknown */\n.ids-list-item,\n:host.ids-list-item {\n  background: var(--ids_color_bg_base);\n  border: 0;\n  border-bottom: var(--ids_size_border_small) solid var(--ids_color_border_soft);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: var(--ids_color_action_neutral_variant);\n  display: block;\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  text-align: left;\n  text-decoration: inherit;\n  width: 100%;\n  /* stylelint-disable-next-line */\n  /* stylelint-disable-next-line */\n  /* stylelint-disable-next-line */\n  /* stylelint-disable-next-line */\n  /* stylelint-disable-next-line */\n  /* stylelint-disable-next-line */\n}\n.ids-list-item .ids-icon-button,\n:host.ids-list-item .ids-icon-button {\n  margin-right: var(--ids_size_general_1x);\n}\n.ids-list-item ::ng-deep .ids-icon-button,\n:host.ids-list-item ::ng-deep .ids-icon-button {\n  margin-right: var(--ids_size_general_1x);\n}\n.ids-list-item__content,\n:host.ids-list-item__content {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: grid;\n  grid-template-areas: \"icon text description action\" \"icon sub-text sub-description action\";\n  grid-template-columns: auto 1fr auto auto;\n  min-height: var(--ids_size_general_64x);\n  overflow: hidden;\n  padding: var(--ids_size_general_20x) 0 calc(var(--ids_size_general_20x) - var(--ids_size_border_small));\n}\n.ids-list-item__icon,\n:host.ids-list-item__icon {\n  align-self: center;\n  grid-area: icon;\n  line-height: 1;\n  margin-right: var(--ids_size_general_16x);\n  text-align: center;\n}\n::ng-deep .ids-list-item__icon,\n::ng-deep :host.ids-list-item__icon {\n  align-self: center;\n  grid-area: icon;\n  line-height: 1;\n  margin-right: var(--ids_size_general_16x);\n  text-align: center;\n}\n.ids-list-item__text,\n:host.ids-list-item__text {\n  grid-area: text;\n  overflow: hidden;\n}\n.ids-list-item__text--double-line,\n:host.ids-list-item__text--double-line {\n  grid-row: span 2;\n}\n::ng-deep .ids-list-item__text,\n::ng-deep :host.ids-list-item__text {\n  grid-area: text;\n  overflow: hidden;\n}\n::ng-deep .ids-list-item__text--double-line,\n::ng-deep :host.ids-list-item__text--double-line {\n  grid-row: span 2;\n}\n.ids-list-item__description,\n:host.ids-list-item__description {\n  grid-area: description;\n  text-align: right;\n  /* stylelint-disable-next-line selector-not-notation */\n}\n.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),\n:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge) {\n  font: var(--ids_textStyle_f02_s16_h24_wbd);\n}\n.ids-list-item__description--double-line,\n:host.ids-list-item__description--double-line {\n  grid-row: span 2;\n}\n::ng-deep .ids-list-item__description,\n::ng-deep :host.ids-list-item__description {\n  grid-area: description;\n  text-align: right;\n  /* stylelint-disable-next-line selector-not-notation */\n}\n::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),\n::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge) {\n  font: var(--ids_textStyle_f02_s16_h24_wbd);\n}\n::ng-deep .ids-list-item__description--double-line,\n::ng-deep :host.ids-list-item__description--double-line {\n  grid-row: span 2;\n}\n.ids-list-item__action,\n:host.ids-list-item__action {\n  align-self: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  grid-area: action;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-left: var(--ids_size_general_8x);\n  min-width: var(--ids_size_general_24x);\n  text-align: center;\n}\n::ng-deep .ids-list-item__action,\n::ng-deep :host.ids-list-item__action {\n  align-self: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  grid-area: action;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-left: var(--ids_size_general_8x);\n  min-width: var(--ids_size_general_24x);\n  text-align: center;\n}\n.ids-list-item__sub-text,\n:host.ids-list-item__sub-text {\n  color: var(--ids_color_action_neutral_base);\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  grid-area: sub-text;\n}\n::ng-deep .ids-list-item__sub-text,\n::ng-deep :host.ids-list-item__sub-text {\n  color: var(--ids_color_action_neutral_base);\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  grid-area: sub-text;\n}\n.ids-list-item__sub-description,\n:host.ids-list-item__sub-description {\n  color: var(--ids_color_action_neutral_base);\n  font: var(--ids_textStyle_f02_s14_h20_wrg);\n  grid-area: sub-description;\n  text-align: right;\n}\n::ng-deep .ids-list-item__sub-description,\n::ng-deep :host.ids-list-item__sub-description {\n  color: var(--ids_color_action_neutral_base);\n  font: var(--ids_textStyle_f02_s14_h20_wrg);\n  grid-area: sub-description;\n  text-align: right;\n}\n.ids-list-item--selector,\n:host.ids-list-item--selector {\n  position: relative;\n}\n@supports (-webkit-touch-callout: none) {\n  .ids-list-item--selector,\n  :host.ids-list-item--selector {\n    overflow: hidden;\n  }\n}\n.ids-list-item--selector .ids-list-item__sub-text,\n:host.ids-list-item--selector .ids-list-item__sub-text {\n  font: var(--ids_textStyle_f02_s14_h20_wrg);\n}\n.ids-list-item--selector ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item--selector ::ng-deep .ids-list-item__sub-text {\n  font: var(--ids_textStyle_f02_s14_h20_wrg);\n}\n.ids-list-item--selector .ids-switch,\n.ids-list-item--selector .ids-radio-button,\n.ids-list-item--selector .ids-checkbox,\n:host.ids-list-item--selector .ids-switch,\n:host.ids-list-item--selector .ids-radio-button,\n:host.ids-list-item--selector .ids-checkbox {\n  position: static;\n}\n.ids-list-item--selector .ids-switch__input,\n.ids-list-item--selector .ids-radio-button__input,\n.ids-list-item--selector .ids-checkbox__input,\n:host.ids-list-item--selector .ids-switch__input,\n:host.ids-list-item--selector .ids-radio-button__input,\n:host.ids-list-item--selector .ids-checkbox__input {\n  outline-offset: 0;\n}\n.ids-list-item--selector ::ng-deep .ids-switch,\n.ids-list-item--selector ::ng-deep .ids-checkbox,\n.ids-list-item--selector ::ng-deep .ids-radio-button,\n:host.ids-list-item--selector ::ng-deep .ids-switch,\n:host.ids-list-item--selector ::ng-deep .ids-checkbox,\n:host.ids-list-item--selector ::ng-deep .ids-radio-button {\n  position: static;\n}\n.ids-list-item--selector ::ng-deep .ids-switch__input,\n.ids-list-item--selector ::ng-deep .ids-checkbox__input,\n.ids-list-item--selector ::ng-deep .ids-radio-button__input,\n:host.ids-list-item--selector ::ng-deep .ids-switch__input,\n:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,\n:host.ids-list-item--selector ::ng-deep .ids-radio-button__input {\n  outline-offset: 0;\n}\n.ids-list-item:where(a), .ids-list-item:where(button), .ids-list-item--action,\n:host.ids-list-item:where(a),\n:host.ids-list-item:where(button),\n:host.ids-list-item--action {\n  background-color: transparent;\n  border-bottom-color: var(--ids_color_border_soft);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  text-decoration: none;\n}\n.ids-list-item:where(a):disabled, .ids-list-item:where(a)[aria-disabled=true], .ids-list-item:where(button):disabled, .ids-list-item:where(button)[aria-disabled=true], .ids-list-item--action:disabled, .ids-list-item--action[aria-disabled=true],\n:host.ids-list-item:where(a):disabled,\n:host.ids-list-item:where(a)[aria-disabled=true],\n:host.ids-list-item:where(button):disabled,\n:host.ids-list-item:where(button)[aria-disabled=true],\n:host.ids-list-item--action:disabled,\n:host.ids-list-item--action[aria-disabled=true] {\n  color: var(--ids_color_action_disabled_variant);\n  cursor: not-allowed;\n}\n.ids-list-item:where(a):disabled .ids-list-item__sub-text,\n.ids-list-item:where(a):disabled .ids-list-item__sub-description, .ids-list-item:where(a)[aria-disabled=true] .ids-list-item__sub-text,\n.ids-list-item:where(a)[aria-disabled=true] .ids-list-item__sub-description, .ids-list-item:where(button):disabled .ids-list-item__sub-text,\n.ids-list-item:where(button):disabled .ids-list-item__sub-description, .ids-list-item:where(button)[aria-disabled=true] .ids-list-item__sub-text,\n.ids-list-item:where(button)[aria-disabled=true] .ids-list-item__sub-description, .ids-list-item--action:disabled .ids-list-item__sub-text,\n.ids-list-item--action:disabled .ids-list-item__sub-description, .ids-list-item--action[aria-disabled=true] .ids-list-item__sub-text,\n.ids-list-item--action[aria-disabled=true] .ids-list-item__sub-description,\n:host.ids-list-item:where(a):disabled .ids-list-item__sub-text,\n:host.ids-list-item:where(a):disabled .ids-list-item__sub-description,\n:host.ids-list-item:where(a)[aria-disabled=true] .ids-list-item__sub-text,\n:host.ids-list-item:where(a)[aria-disabled=true] .ids-list-item__sub-description,\n:host.ids-list-item:where(button):disabled .ids-list-item__sub-text,\n:host.ids-list-item:where(button):disabled .ids-list-item__sub-description,\n:host.ids-list-item:where(button)[aria-disabled=true] .ids-list-item__sub-text,\n:host.ids-list-item:where(button)[aria-disabled=true] .ids-list-item__sub-description,\n:host.ids-list-item--action:disabled .ids-list-item__sub-text,\n:host.ids-list-item--action:disabled .ids-list-item__sub-description,\n:host.ids-list-item--action[aria-disabled=true] .ids-list-item__sub-text,\n:host.ids-list-item--action[aria-disabled=true] .ids-list-item__sub-description {\n  color: inherit;\n}\n.ids-list-item:where(a):disabled ::ng-deep .ids-list-item__sub-text,\n.ids-list-item:where(a):disabled ::ng-deep .ids-list-item__sub-description, .ids-list-item:where(a)[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,\n.ids-list-item:where(a)[aria-disabled=true] ::ng-deep .ids-list-item__sub-description, .ids-list-item:where(button):disabled ::ng-deep .ids-list-item__sub-text,\n.ids-list-item:where(button):disabled ::ng-deep .ids-list-item__sub-description, .ids-list-item:where(button)[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,\n.ids-list-item:where(button)[aria-disabled=true] ::ng-deep .ids-list-item__sub-description, .ids-list-item--action:disabled ::ng-deep .ids-list-item__sub-text,\n.ids-list-item--action:disabled ::ng-deep .ids-list-item__sub-description, .ids-list-item--action[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,\n.ids-list-item--action[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,\n:host.ids-list-item:where(a):disabled ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item:where(a):disabled ::ng-deep .ids-list-item__sub-description,\n:host.ids-list-item:where(a)[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item:where(a)[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,\n:host.ids-list-item:where(button):disabled ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item:where(button):disabled ::ng-deep .ids-list-item__sub-description,\n:host.ids-list-item:where(button)[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item:where(button)[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,\n:host.ids-list-item--action:disabled ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item--action:disabled ::ng-deep .ids-list-item__sub-description,\n:host.ids-list-item--action[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,\n:host.ids-list-item--action[aria-disabled=true] ::ng-deep .ids-list-item__sub-description {\n  color: inherit;\n}\n@media (hover: hover) and (pointer: fine) {\n  .ids-list-item:where(a), .ids-list-item:where(button), .ids-list-item--action,\n  :host.ids-list-item:where(a),\n  :host.ids-list-item:where(button),\n  :host.ids-list-item--action {\n    /* stylelint-disable selector-not-notation */\n  }\n  .ids-list-item:where(a):hover:not(:disabled):not([aria-disabled=true]), .ids-list-item:where(a):focus-visible:not(:disabled):not([aria-disabled=true]), .ids-list-item:where(button):hover:not(:disabled):not([aria-disabled=true]), .ids-list-item:where(button):focus-visible:not(:disabled):not([aria-disabled=true]), .ids-list-item--action:hover:not(:disabled):not([aria-disabled=true]), .ids-list-item--action:focus-visible:not(:disabled):not([aria-disabled=true]),\n  :host.ids-list-item:where(a):hover:not(:disabled):not([aria-disabled=true]),\n  :host.ids-list-item:where(a):focus-visible:not(:disabled):not([aria-disabled=true]),\n  :host.ids-list-item:where(button):hover:not(:disabled):not([aria-disabled=true]),\n  :host.ids-list-item:where(button):focus-visible:not(:disabled):not([aria-disabled=true]),\n  :host.ids-list-item--action:hover:not(:disabled):not([aria-disabled=true]),\n  :host.ids-list-item--action:focus-visible:not(:disabled):not([aria-disabled=true]) {\n    background-color: var(--ids_color_action_neutral_base_soft);\n  }\n}\n.ids-list-item--line-off,\n:host.ids-list-item--line-off {\n  border-bottom: 0;\n}\n.ids-list-item--line-off .ids-list-item__content,\n:host.ids-list-item--line-off .ids-list-item__content {\n  padding: var(--ids_size_general_20x) 0;\n}\n\n.ids-list,\n:host.ids-list {\n  background-color: var(--ids_color_bg_base);\n  color: var(--ids_color_action_neutral_variant);\n  font: var(--ids_textStyle_f02_s16_h24_wrg);\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsList } from '@ids/react';
 * ```
 */
const IdsList = _a => {
  var {
      className = '',
      children,
      tag = 'ul'
    } = _a,
    props = __rest(_a, ["className", "children", "tag"]);
  const classes = generateClasses({
    'ids-list': true,
    [className]: className
  });
  const template = {
    dl: jsx("dl", Object.assign({
      className: classes
    }, props, {
      children: children
    })),
    ol: jsx("ol", Object.assign({
      role: "list",
      className: classes
    }, props, {
      children: children
    })),
    ul: jsx("ul", Object.assign({
      role: "list",
      className: classes
    }, props, {
      children: children
    }))
  };
  return template[tag];
};

const useFormSelection = () => {
  const [input, setInput] = useState();
  const [labelIds, setLabelIds] = useState([]);
  const setLabelId = (labelId = '') => {
    if (!labelId || labelIds.includes(labelId)) {
      return;
    }
    setLabelIds([...labelIds, labelId]);
  };
  return {
    input,
    setInput,
    labelIds,
    setLabelId
  };
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsLi } from '@ids/react';
 * ```
 */
const IdsLiContent = _a => {
  var {
      className = '',
      children,
      lineOff,
      tagName = 'li',
      actionIcon = 'seta_direita'
    } = _a,
    props = __rest(_a, ["className", "children", "lineOff", "tagName", "actionIcon"]);
  const isAction = tagName === 'a' || tagName === 'button';
  const {
    input: input
  } = useContext(FormSelectionContext);
  const classes = useMemo(() => generateClasses({
    'ids-list-item': true,
    'ids-list-item--action': isAction,
    'ids-list-item--line-off': lineOff,
    'ids-list-item--selector': !!input,
    [className]: className
  }), [className, input, isAction, lineOff]);
  const content = jsxs("span", Object.assign({
    className: "ids-list-item__content",
    role: input ? undefined : 'text'
  }, {
    children: [children, isAction && jsx(IdsIcon, Object.assign({
      size: "M",
      className: "ids-list-item__action"
    }, {
      children: actionIcon
    }))]
  }));
  const templates = {
    a: jsx("li", {
      children: jsx("a", Object.assign({
        className: classes
      }, props, {
        children: content
      }))
    }),
    button: jsx("li", {
      children: jsx("button", Object.assign({
        className: classes
      }, props, {
        children: content
      }))
    }),
    li: jsx("li", Object.assign({
      className: classes
    }, props, {
      children: content
    }))
  };
  return templates[tagName];
};
const IdsLi = props => {
  const formSelection = useFormSelection();
  return jsx(FormSelectionContext.Provider, Object.assign({
    value: formSelection
  }, {
    children: jsx(IdsLiContent, Object.assign({}, props))
  }));
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsLiText } from '@ids/react';
 * ```
 */
const IdsLiText = _a => {
  var {
      className = '',
      children,
      id: externalId
    } = _a,
    props = __rest(_a, ["className", "children", "id"]);
  const [doubleLine, setDoubleLine] = useState(false);
  const ref = useRef();
  const {
    input,
    setLabelId
  } = useContext(FormSelectionContext);
  const tag = (input === null || input === void 0 ? void 0 : input.tagName) === 'INPUT' ? 'label' : 'span';
  const id = externalId || ((input === null || input === void 0 ? void 0 : input.id) ? `${input === null || input === void 0 ? void 0 : input.id}-text` : undefined);
  const classes = generateClasses({
    'ids-list-item__text': true,
    'ids-list-item__text--double-line': doubleLine,
    [className]: className
  });
  useEffect(() => {
    var _a, _b;
    if ((ref === null || ref === void 0 ? void 0 : ref.current) && !((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.classList.contains('ids-list-item__sub-text'))) {
      setDoubleLine(true);
    }
  }, []);
  useEffect(() => {
    if (setLabelId && input && id) {
      setLabelId(id);
    }
  }, [id, input, setLabelId]);
  const content = jsxs(Fragment, {
    children: [children, jsx("span", Object.assign({
      className: "ids-sr-only"
    }, {
      children: "\u00A0"
    }))]
  });
  const templates = {
    span: jsx("span", Object.assign({
      id: id,
      className: classes,
      "aria-hidden": !!input || undefined
    }, props, {
      ref: ref
    }, {
      children: content
    })),
    label: jsx("label", Object.assign({
      "aria-hidden": true,
      id: id,
      className: classes,
      htmlFor: input === null || input === void 0 ? void 0 : input.id
    }, props, {
      ref: ref
    }, {
      children: content
    }))
  };
  return templates[tag];
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsLiSubText } from '@ids/react';
 * ```
 */
const IdsLiSubText = _a => {
  var {
      className = '',
      children,
      id: externalId
    } = _a,
    props = __rest(_a, ["className", "children", "id"]);
  const {
    input,
    setLabelId
  } = useContext(FormSelectionContext);
  const id = externalId || ((input === null || input === void 0 ? void 0 : input.id) ? `${input === null || input === void 0 ? void 0 : input.id}-sub-text` : undefined);
  const tag = (input === null || input === void 0 ? void 0 : input.tagName) === 'INPUT' ? 'label' : 'span';
  const classes = generateClasses({
    'ids-list-item__sub-text': true,
    [className]: className
  });
  useEffect(() => {
    if (setLabelId && input && id) {
      setLabelId(id);
    }
  }, [id, input, setLabelId]);
  const content = jsxs(Fragment, {
    children: [children, jsx("span", Object.assign({
      className: "ids-sr-only"
    }, {
      children: "\u00A0"
    }))]
  });
  const templates = {
    span: jsx("span", Object.assign({
      id: id,
      className: classes,
      "aria-hidden": !!input || undefined
    }, props, {
      children: content
    })),
    label: jsx("label", Object.assign({
      "aria-hidden": true,
      id: id,
      className: classes,
      htmlFor: input === null || input === void 0 ? void 0 : input.id
    }, props, {
      children: content
    }))
  };
  return templates[tag];
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsLiDescription } from '@ids/react';
 * ```
 */
const IdsLiDescription = _a => {
  var {
      className = '',
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  const [doubleLine, setDoubleLine] = useState(false);
  const ref = useRef();
  const classes = generateClasses({
    'ids-list-item__description': true,
    'ids-list-item__description--double-line': doubleLine,
    [className]: className
  });
  useEffect(() => {
    var _a, _b;
    if ((ref === null || ref === void 0 ? void 0 : ref.current) && !((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.classList.contains('ids-list-item__sub-description'))) {
      setDoubleLine(true);
    }
  }, []);
  return jsxs("span", Object.assign({
    ref: ref,
    className: classes
  }, props, {
    children: [children, jsx("span", Object.assign({
      className: "ids-sr-only"
    }, {
      children: "\u00A0"
    }))]
  }));
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsLiSubDescription } from '@ids/react';
 * ```
 */
const IdsLiSubDescription = _a => {
  var {
      className = '',
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  const classes = generateClasses({
    'ids-list-item__sub-description': true,
    [className]: className
  });
  return jsx("span", Object.assign({
    className: classes
  }, props, {
    children: children
  }));
};

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsLiIcon } from '@ids/react';
 * ```
 */
const IdsLiIcon = _a => {
  var {
      iconProps,
      className = '',
      children
    } = _a,
    props = __rest(_a, ["iconProps", "className", "children"]);
  const classes = generateClasses({
    'ids-list-item__icon': true,
    [className]: className
  });
  function renderIcon() {
    if (typeof children == 'string') {
      return jsx(IdsIcon, Object.assign({
        size: "M"
      }, iconProps, {
        children: children
      }));
    }
    return children;
  }
  return jsx("span", Object.assign({
    className: classes
  }, props, {
    "aria-hidden": "true"
  }, {
    children: renderIcon()
  }));
};

export { IdsList as I, IdsLiContent as a, IdsLi as b, IdsLiText as c, IdsLiSubText as d, IdsLiDescription as e, IdsLiSubDescription as f, IdsLiIcon as g };
//# sourceMappingURL=list-item-icon.js.map
